import { useEffect } from 'react';
import { listGroupsWatchData } from './graphql/queries';

export default function useGroups({ setWatchDataError, useLazyGraphQLQuery }) {
  const [listGroupsWatchDataQuery, listGroupsWatchDataResponse] =
    useLazyGraphQLQuery(listGroupsWatchData);

  useEffect(() => {
    const { error } = listGroupsWatchDataResponse;

    if (error) {
      setWatchDataError(true);
    }
  }, [listGroupsWatchDataResponse]);

  return {
    organizationGroupsStats:
      listGroupsWatchDataResponse.data?.listGroupsWatchData,
    loadingGroups: listGroupsWatchDataResponse.loading,
    fetchGroups: listGroupsWatchDataQuery,
  };
}
